import { ref } from 'vue'

// State to track if the router is currently navigating
export const isRouterNavigating = ref(false)

/**
 * Returns a promise that resolves when the router is idle (not navigating)
 * @returns Promise that resolves when router is idle
 */
export function waitUntilRouterIdle(): Promise<void> {
  return new Promise((resolve) => {
    if (!isRouterNavigating.value) {
      resolve()
      return
    }

    const checkInterval = setInterval(() => {
      if (!isRouterNavigating.value) {
        clearInterval(checkInterval)
        resolve()
      }
    }, 50)
  })
}